import { render, staticRenderFns } from "./AreasSilvestresProtegidasParaguai.vue?vue&type=template&id=2cfef49a&lang=pug"
import script from "./AreasSilvestresProtegidasParaguai.vue?vue&type=script&lang=js"
export * from "./AreasSilvestresProtegidasParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports